import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import InventoryManagement from './pages/inventory-management';
import Login from './pages/login';
import MealPlanning from './pages/meal-planning';
import Register from './pages/register';
import TripSetup from './pages/trip-setup';
import AccountSettings from './pages/account-settings';
import TripSettings from './pages/trip-settings';
import TripDashboard from './pages/trip-dashboard';
import ShoppingList from './pages/shopping-list';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Login />} />
        <Route path="/inventory-management" element={<InventoryManagement />} />
        <Route path="/login" element={<Login />} />
        <Route path="/meal-planning" element={<MealPlanning />} />
        <Route path="/register" element={<Register />} />
        <Route path="/trip-setup" element={<TripSetup />} />
        <Route path="/trip-dashboard" element={<TripDashboard />} />
        <Route path="/shopping-list" element={<ShoppingList />} />
        <Route path="/account-settings" element={<AccountSettings />} />
        <Route path="/trip-settings" element={<TripSettings />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
